export const byRelevance = (linkA, linkB) => {
  const relevanceA = linkA.entityContent?.relevance ?? Infinity;
  const relevanceB = linkB.entityContent?.relevance ?? Infinity;

  return relevanceA - relevanceB;
};
